import { useEffect } from "react";
const useKeyboardEvent = (ref, callback, key, events = ["keydown"]) => {
  useEffect(() => {
    const handleKeyboardEvent = (event) => {
      if (event.key === key || Array.isArray(key) && key.includes(event.key)) {
        callback(event);
      }
    };
    events.forEach((eventName) => {
      var _a;
      return (_a = ref.current) == null ? void 0 : _a.addEventListener(eventName, handleKeyboardEvent);
    });
    return () => {
      events.forEach((eventName) => {
        var _a;
        return (_a = ref.current) == null ? void 0 : _a.removeEventListener(eventName, handleKeyboardEvent);
      });
    };
  }, [ref, callback, events, key]);
};
export {
  useKeyboardEvent
};
//# sourceMappingURL=useKeyboardEvent.js.map
